package com.neurobs.ccab

case class LogTestRun
(
  testRunDetail: TestRunDetail,
  tests: List[Test]
) {
  def startTime = testRunDetail.start_time
  def testName = {
    val testIndex = testRunDetail.run.test
    try {
      Some(tests(testIndex).name)
    } catch {
      case _: Throwable => None
    }
  }
  def error = testRunDetail.run.error

  def comments = testRunDetail.comments
}

case class Run(
                logTestRun: Option[LogTestRun],
                testRun: Option[TestRunDisplayData]
              ) {

  def startTime = testRun.map(_.testRun.startTime) match {
    case Some(timestamp) => Some(timestamp)
    case None => logTestRun.map(_.startTime)
  }

  def testName = testRun.flatMap(_.testName) match {
    case Some(testName) => Some(testName)
    case None => logTestRun.flatMap(_.testName)
  }

  def error = testRun.flatMap(_.testRun.runError) match {
    case Some(error) => Some(error)
    case None => logTestRun.flatMap(_.error)
  }
}

class RunMatch(testRunDetails: List[TestRunDetail], tests: List[Test], testRuns: List[TestRunDisplayData]) {

  private def initializeMatches() = {
    testRunDetails.map(_ -> None).toMap[TestRunDetail, Option[TestRunDisplayData]]
  }

  private var matches = initializeMatches()

  private def updateClosestTimeMatches(logTestRun: TestRunDetail, testRun: TestRunDisplayData) = {
    matches = matches.updated(logTestRun, Some(testRun))
  }

  private def findClosestEmptyMatch(testRun: TestRunDisplayData) = {
    val unmatched = testRunDetails.filter(matches.get(_).map(_.isEmpty).getOrElse(true))
    val precedingUnmatched = unmatched.filter(_.start_time.instant.getEpochSecond <= testRun.testRun.startTime.instant.getEpochSecond)
    precedingUnmatched.sortBy(_.start_time.instant.getEpochSecond).lastOption
  }

  def fillClosestTimeMatches() = {
    testRuns.foreach(testRun => {
      findClosestEmptyMatch(testRun) match {
        case None =>
        case Some(testRunDetail) => updateClosestTimeMatches(testRunDetail, testRun)
      }
    })
  }

  fillClosestTimeMatches()


  def getRuns = matches.map(pair => {
    val (testRunDetail, testRunOpt) = pair
    val logTestRun = LogTestRun(testRunDetail, tests)
    testRunOpt match {
      case None => Run(Some(logTestRun), None)
      case Some(testRun) => Run(Some(logTestRun), Some(testRun))
    }
  }).toList


}
